var render, staticRenderFns
import script from "./OutlinedButton.vue?vue&type=script&lang=ts&"
export * from "./OutlinedButton.vue?vue&type=script&lang=ts&"
import style0 from "./OutlinedButton.vue?vue&type=style&index=0&id=e3d80612&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d80612",
  null
  
)

export default component.exports